import api from '../../services/api';
import BaseService from '../BaseService';

class AnonimizacaoService extends BaseService {
    constructor() {
        super('suporte/anonimizacao');
    }

    /**
     * Gera a prévia da anonimização por regras do programa.
     * @param {number} programaId
     * @param {boolean} substituir - descarta uma prévia em aberto e gera outra
     */
    previa(programaId, substituir = true) {
        return api.post(`${this.resource}regras/previa/`, {
            programa_id: programaId,
            substituir,
        });
    }

    /**
     * Processa o próximo lote de uma execução. Chamar em loop até `restantes === 0`.
     * IRREVERSÍVEL.
     * @param {number} execucaoId
     * @param {string} confirmacao - nome exato do programa
     * @param {number} tamanhoLote - 1 a 100
     */
    executar(execucaoId, confirmacao, tamanhoLote) {
        return api.post(`${this.resource}regras/executar/`, {
            execucao_id: execucaoId,
            confirmacao,
            tamanho_lote: tamanhoLote,
        });
    }

    /**
     * Histórico de execuções (paginado).
     * @param {Object} params - programa_id, status, page
     */
    listarExecucoes(params) {
        return api.get(`${this.resource}execucoes/`, { params });
    }

    /**
     * Itens de uma execução (paginado), com o resumo da execução em `execucao`.
     * @param {number} id
     * @param {Object} params - status, page
     */
    detalheExecucao(id, params) {
        return api.get(`${this.resource}execucoes/${id}/`, { params });
    }
}

const anonimizacaoService = new AnonimizacaoService();
export default anonimizacaoService;
